var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _ellipse2, _circle, _path7, _path8, _circle2, _mask, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNorecentuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 92,
    viewBox: "0 0 120 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 91.4783C93.1371 91.4783 120 81.7453 120 69.7391C120 57.7329 93.1371 48 60 48C26.8629 48 0 57.7329 0 69.7391C0 81.7453 26.8629 91.4783 60 91.4783Z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8574 55.7148V70.2863C37.8574 73.3633 48.2188 75.8577 61.0003 75.8577C73.7817 75.8577 84.1431 73.3633 84.1431 70.2863V55.7148",
    stroke: "#ADB5C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.001 53.0225C39.3891 53.7858 37.8574 54.714 37.8574 55.715C37.8574 58.3186 48.2188 60.4293 61.0003 60.4293C73.7817 60.4293 84.1431 58.3186 84.1431 55.715C84.1431 54.714 82.6115 53.7858 79.9996 53.0225",
    stroke: "#ADB5C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5889 2.93443C42.5765 3.90085 41.783 4.67423 40.8166 4.66183L40.5666 4.65862C35.5964 4.59484 31.5156 8.57224 31.4518 13.5424L31.4223 15.8422C31.4103 16.781 30.6395 17.5323 29.7006 17.5202V17.5202C28.7618 17.5082 28.0106 16.7374 28.0226 15.7986L28.0521 13.4988C28.1442 6.31965 33.4324 1.06678 40.6115 1.15891L40.8615 1.16211C41.8279 1.17452 42.6013 1.96801 42.5889 2.93443V2.93443Z",
    stroke: "#ADB5C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8574 35.1426V49.714C37.8574 52.791 48.2188 55.2854 61.0003 55.2854C73.7817 55.2854 84.1431 52.791 84.1431 49.714V35.1426",
    stroke: "#ADB5C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.0003,
    cy: 35.143,
    rx: 23.1429,
    ry: 4.71429,
    stroke: "#ADB5C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0003 34.7141C73.7817 34.7141 84.1431 32.2197 84.1431 29.1427V14.5713H37.8574V29.1427C37.8574 32.2197 48.2188 34.7141 61.0003 34.7141Z",
    fill: "white",
    stroke: "#ADB5C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 14.1429,
    rx: 24,
    ry: 5.14286,
    fill: "#ADB5C2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 53,
    r: 13,
    fill: "white",
    stroke: "#ADB5C2",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 46.5C83.5 45.6716 84.1716 45 85 45V45C85.8284 45 86.5 45.6716 86.5 46.5V52.5C86.5 53.3284 85.8284 54 85 54V54C84.1716 54 83.5 53.3284 83.5 52.5V46.5Z",
    stroke: "#BDC6DB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 59.5C83.5 60.3284 84.1716 61 85 61V61C85.8284 61 86.5 60.3284 86.5 59.5V59.5C86.5 58.6716 85.8284 58 85 58V58C84.1716 58 83.5 58.6716 83.5 59.5V59.5Z",
    stroke: "#BDC6DB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 66,
    r: 13,
    fill: "white",
    stroke: "#ADB5C2",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-1_11046_200694",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6853 61.703C42.6853 63.7482 41.0274 65.4061 38.9823 65.4061C36.9371 65.4061 35.2792 63.7482 35.2792 61.703C35.2792 59.6579 36.9371 58 38.9823 58C41.0274 58 42.6853 59.6579 42.6853 61.703ZM35.7474 67.3721C33.1255 67.3721 31 69.4976 31 72.1196C31 72.9062 31.6377 73.5438 32.4242 73.5438H45.6222C46.4088 73.5438 47.0465 72.9062 47.0465 72.1196C47.0465 69.4976 44.921 67.3721 42.2991 67.3721H39.0232H35.7474Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9823 67.4061C42.132 67.4061 44.6853 64.8527 44.6853 61.703H40.6853C40.6853 62.6436 39.9228 63.4061 38.9823 63.4061V67.4061ZM33.2792 61.703C33.2792 64.8527 35.8326 67.4061 38.9823 67.4061V63.4061C38.0417 63.4061 37.2792 62.6436 37.2792 61.703H33.2792ZM38.9823 56C35.8326 56 33.2792 58.5533 33.2792 61.703H37.2792C37.2792 60.7625 38.0417 60 38.9823 60V56ZM44.6853 61.703C44.6853 58.5533 42.132 56 38.9823 56V60C39.9228 60 40.6853 60.7625 40.6853 61.703H44.6853ZM33 72.1196C33 70.6022 34.2301 69.3721 35.7474 69.3721V65.3721C32.0209 65.3721 29 68.3931 29 72.1196H33ZM32.4242 71.5438C32.7422 71.5438 33 71.8016 33 72.1196H29C29 74.0108 30.5331 75.5438 32.4242 75.5438V71.5438ZM45.6222 71.5438H32.4242V75.5438H45.6222V71.5438ZM45.0465 72.1196C45.0465 71.8016 45.3043 71.5438 45.6222 71.5438V75.5438C47.5134 75.5438 49.0465 74.0108 49.0465 72.1196H45.0465ZM42.2991 69.3721C43.8164 69.3721 45.0465 70.6022 45.0465 72.1196H49.0465C49.0465 68.3931 46.0256 65.3721 42.2991 65.3721V69.3721ZM39.0232 69.3721H42.2991V65.3721H39.0232V69.3721ZM35.7474 69.3721H39.0232V65.3721H35.7474V69.3721Z",
    fill: "#BDC6DB",
    mask: "url(#path-13-inside-1_11046_200694)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorecentuser);
export default __webpack_public_path__ + "static/media/norecentuser.70b07f8b480370542918bb2229214f3f.svg";
export { ForwardRef as ReactComponent };